var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtistManagement01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artist Management-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.93,
    cy: 20.22,
    r: 2.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.07,
    cy: 17.29,
    r: 2.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.87 20.22 6.87 1.16 23 1.16 23 17.29"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.87,
    y1: 5.56,
    x2: 23,
    y2: 5.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistManagement01);
export default __webpack_public_path__ + "static/media/Artist_Management_01.df436c1e3d39a0f18c05a0564b5e7736.svg";
export { ForwardRef as ReactComponent };